import { render, staticRenderFns } from "./EventTrainingDetails.vue?vue&type=template&id=6985de26&scoped=true&"
import script from "./EventTrainingDetails.vue?vue&type=script&lang=js&"
export * from "./EventTrainingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6985de26",
  null
  
)

export default component.exports